// extracted by mini-css-extract-plugin
module.exports = {"headings":"CreatePollForm_headings__2fBsA","title":"CreatePollForm_title__VgaUG","desc":"CreatePollForm_desc__3VQSK"};